import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import config from '@nerdwallet/app-config';
import { InMemoryCache, BROWSER_KEY } from '..';
import getApolloClient, { getPossibleTypes, getTypePolicies } from './shared';
/**
 * Light wrapper around the shared apollo-client implementation.
 */
export default (function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var acOptions = _objectSpread({
    // eslint-disable-next-line no-console
    log: function log(msg) {
      return config.DEBUG && console.warn(msg);
    },
    connectToDevTools: config.DEBUG
  }, options);
  if (options.createCache) {
    acOptions.cache = options.createCache().restore(window[BROWSER_KEY]);
    delete acOptions.createCache;
  } else if (!options.cache) {
    acOptions.cache = new InMemoryCache({
      possibleTypes: getPossibleTypes(options),
      typePolicies: getTypePolicies(options)
    }).restore(window[BROWSER_KEY]);
  }
  return getApolloClient(acOptions);
});